<div class="container-fluid">
  @if (loading) {
  <div class="loading-overlay">
    <mat-spinner></mat-spinner>
  </div>
  }

  <form [formGroup]="userForm" class="user-form">

    <div class="card section">
      <h5 class="section-title">User Details</h5>

      <div class="row g-3 align-items-center">

        <!-- Client ID -->
        <div class="col-md-4 d-flex align-items-center">
          <label class="me-2 mb-0" style="min-width: 120px;">
            Client ID <span class="required">*</span>
          </label>

          <p-select [options]="clientNameListDropDown" formControlName="clientIdSelectedGroup"
            placeholder="Select Client" appendTo="body" class="flex-grow-1"
            [ngClass]="{
                'error-input': userForm.get('clientIdSelectedGroup')?.invalid && (userForm.get('clientIdSelectedGroup')?.touched || userForm.get('clientIdSelectedGroup')?.dirty),
                'valid-input': userForm.get('clientIdSelectedGroup')?.valid && (userForm.get('clientIdSelectedGroup')?.touched || userForm.get('clientIdSelectedGroup')?.dirty)
              }">
          </p-select>
        </div>

        <!-- MPID -->
        <div class="col-md-4 d-flex align-items-center">
          <label class="me-2 mb-0" style="min-width: 100px;">
            MPID's <span class="required">*</span>
          </label>

          <div class="flex-grow-1">

        <p-multiSelect 
            [options]="clientNameListDropDown" 
            optionLabel="label" 
            optionValue="value"
            [filter]="true" 
            formControlName="mpidSelectedGroup"
            placeholder="Select MPID's" 
            appendTo="body"
            class="w-100" 
            [ngClass]="{
              'error-input': userForm.get('mpidSelectedGroup')?.invalid && (userForm.get('mpidSelectedGroup')?.touched || userForm.get('mpidSelectedGroup')?.dirty),
              'valid-input': userForm.get('mpidSelectedGroup')?.valid && (userForm.get('mpidSelectedGroup')?.touched || userForm.get('mpidSelectedGroup')?.dirty)
            }"
            (onFilter)="handleFilter($event)"
            #ms>
            <ng-template pTemplate="header">
                <div class="custom-dropdown-header-action" *ngIf="showAddButton">
                    <button 
                        type="button" 
                        pButton 
                        label="Add new: '{{ filterSearchText }}'" 
                        icon="pi pi-plus" 
                        class="p-button-text p-button-sm p-1 w-100 text-left"
                        (click)="addNewMPIDValue(filterSearchText, ms)">
                    </button>
                </div>
            </ng-template>
        </p-multiSelect>






          </div>
        </div>

        <!-- Role -->
        <div class="col-md-4 d-flex align-items-center">
          <label class="me-2 mb-0" style="min-width: 100px;">
            Role <span class="required">*</span>
          </label>

          <div class="flex-grow-1">
            <p-select [options]="rolesListDropDown" formControlName="roleSelectedGroup" placeholder="Select Role"
              appendTo="body" class="w-100" [ngClass]="{
                'error-input': userForm.get('roleSelectedGroup')?.invalid && (userForm.get('roleSelectedGroup')?.touched || userForm.get('roleSelectedGroup')?.dirty),
                'valid-input': userForm.get('roleSelectedGroup')?.valid && (userForm.get('roleSelectedGroup')?.touched || userForm.get('roleSelectedGroup')?.dirty)
              }">
            </p-select>
          </div>
        </div>

      </div>
    </div>


    <div class="card section">
      <h5 class="section-title">Profile - Login Information</h5>

      <div class="row g-3 align-items-center">

        <!-- First Name -->
        <div class="col-md-6 d-flex align-items-center">
          <label class="me-2 mb-0" style="min-width: 120px;">
            First Name <span class="required">*</span>
          </label>

          <input class="form-control flex-grow-1" formControlName="firstName" [ngClass]="{
                'error-input': userForm.get('firstName')?.invalid && (userForm.get('firstName')?.touched || userForm.get('firstName')?.dirty),
                'valid-input': userForm.get('firstName')?.valid && (userForm.get('firstName')?.touched || userForm.get('firstName')?.dirty)
              }" />
        </div>

        <!-- Last Name -->
        <div class="col-md-6 d-flex align-items-center">
          <label class="me-2 mb-0" style="min-width: 120px;">
            Last Name <span class="required">*</span>
          </label>

          <input class="form-control flex-grow-1" formControlName="lastName" [ngClass]="{
                'error-input': userForm.get('lastName')?.invalid && (userForm.get('lastName')?.touched || userForm.get('lastName')?.dirty),
                'valid-input': userForm.get('lastName')?.valid && (userForm.get('lastName')?.touched || userForm.get('lastName')?.dirty)
              }" />
        </div>

        <!-- Email -->
        <div class="col-md-6 d-flex align-items-center">
          <label class="me-2 mb-0" style="min-width: 120px;">
            Email <span class="required">*</span>
          </label>

          <div class="flex-grow-1">
            <input type="email" class="form-control" formControlName="email" [ngClass]="{
                'error-input': userForm.get('email')?.invalid && (userForm.get('email')?.touched || userForm.get('email')?.dirty),
                'valid-input': userForm.get('email')?.valid && (userForm.get('email')?.touched || userForm.get('email')?.dirty)
              }" placeholder="Enter Email" />

            @if (userForm.get('email')?.touched &&
            userForm.get('email')?.invalid) {
            <small class="error">Valid email is required</small>
            }
          </div>
        </div>
      </div>
      <br>
      <div class="card section">
        <h5 class="section-title">Security</h5>

        <div class="d-flex align-items-center row flex-wrap">

          <div class="col-md-6">
            <div class="d-flex align-items-center gap-4">
              <label class="mb-0">Set Permanent Password</label>

              <div class="form-check form-switch m-0">
                <input type="checkbox" class="form-check-input" formControlName="permanentPasswordEnabled"
                  (change)="onPasswordToggle($event)" />
              </div>

              <span>
                {{ userForm.get('permanentPasswordEnabled')?.value ? 'Enabled' : 'Disabled' }}
              </span>

              <span class="info-hover">
                <span class="material-icons" title="Info">
                  info
                </span>
                <span class="tooltip-text">
                  If the password is set, it will be permanent. If not, MFA will assign a temporary password, and the
                  user will need to log in and update it.
                </span>
              </span>
            </div>
          </div>


          <!-- New Password -->
          <div class="col-md-6  align-items-center">
            <div class="flex-wrap d-flex align-items-center">
              <label class="me-2 mb-0" style="min-width: 140px;">
                New Password <span class="required">*</span>
              </label>

              <div class="password-wrapper flex-grow-1">
                <input [type]="showChangePassword ? 'text' : 'password'" class="form-control"
                  formControlName="changePassword" [ngClass]="{
                'error-input': userForm.get('changePassword')?.invalid && (userForm.get('changePassword')?.touched || userForm.get('changePassword')?.dirty),
                'valid-input': userForm.get('changePassword')?.valid && (userForm.get('changePassword')?.touched || userForm.get('changePassword')?.dirty)
              }" placeholder="Enter password" />
                <span class="toggle-icon" (click)="toggleChangePassword()">
                  <i [class]="showChangePassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                </span>
              </div>

            </div>
            <div class=" row flex-wrap align-items-center ">
              @if (userForm.get('changePassword')?.touched &&
              userForm.get('changePassword')?.errors) {
              @if (userForm.get('changePassword')?.errors?.['pattern']) {
              <small class="error">
                Password must contain:
                1 uppercase, 1 lowercase, 1 number,
                1 special character, and be at least 8 characters long
              </small>
              }
              }
            </div>
          </div>



        </div>
        <br>
        <!-- MFA -->
        <div class="d-flex align-items-center row flex-wrap">

          <div class="col-md-6">
            <div class="d-flex align-items-center gap-4">
              <label class="mb-0">MFA Enable </label>

              <div class="form-check form-switch m-0">
                <input type="checkbox" class="form-check-input" formControlName="mfaEnabled"
                  (change)="onMfaToggle($event)" />
              </div>

              <span>
                {{ userForm.get('mfaEnabled')?.value ? 'Enabled' : 'Disabled' }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex align-items-center gap-4">
              <label class="mb-0" style="min-width: 125px;">MFA Method </label>
              <input class="form-control w-auto" class="form-control" value="Email OTP" disabled />
            </div>
          </div>

        </div>
        
        <br>
        <!-- Activate USER -->
        <div class="d-flex align-items-center row flex-wrap">

          <div class="col-md-6">
            <div class="d-flex align-items-center gap-4">
              <label class="mb-0">User Status </label>

              <div class="form-check form-switch m-0">
               :
              </div>
              <span>
                {{ userForm.get('activeDropdown')?.value =='Y' ? 'Active' : 'Disabled' }}
              </span>
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex align-items-center gap-4">
              <label class="mb-0" style="min-width: 125px;">Active </label>
                   <p-select [options]="actions" formControlName="activeDropdown" placeholder="Select Status" appendTo="body"
            [ngClass]="{
                'error-input': userForm.get('activeDropdown')?.invalid && (userForm.get('activeDropdown')?.touched || userForm.get('activeDropdown')?.dirty),
                'valid-input': userForm.get('activeDropdown')?.valid && (userForm.get('activeDropdown')?.touched || userForm.get('activeDropdown')?.dirty)
              }" class="flex-grow-1">
          </p-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-dialog-buttonpane ui-helper-clearfix float-right">
      <p-button type="button" label="Discard" icon="fa fa-close" class="userActionBtn" (click)="resetForm()"></p-button>
      @if(!isEditAction){
      <p-button type="button" label="Add User" icon="fa fa-check" [disabled]="userForm.invalid" class="userActionBtn"
        (click)="addUser()">
      </p-button>
    }
    @if(isEditAction){
        <p-button type="button" label="Update User" icon="fa fa-check" [disabled]="userForm.invalid" class="userActionBtn"
        (click)="updateUser()">
      </p-button>
    }
    </div>
  </form>
</div>